import React from "react";

const Footer=()=>{
return(
    <div className=" footer d__flex align__items__center justify__content__space__between pz-10" style={{" padding":"10px 20px","zIndex":"100","background-color": "black"}}>

        <span className="copyright" style={{"color":"white","padding-left":"16px","padding-bottom":"4px","fontSize":"14px","opacity":"0.75"}}>Copyright @Developer_12. All Rights Reserved.</span>
    </div>
)
};

export default Footer;